import { Col, Form, Row } from 'antd';
import { useTranslate } from '@refinedev/core';

import TextInput from 'components/text/textInput';
import TextAreaInput from 'components/textarea/textAreaInput';
import constants from 'core/constants/Constants';
import RangeInput from 'components/date/rangeInput';
import SegmentInput from 'components/segment/SegmentInput';
import DropdownInput from 'components/dropdown/dropDownInput';
import regex from 'core/constants/Regex';

const RulePlanForm = ({
  formData,
  eventHandler,
  stateData,
  staticData,
  configData,
}: any) => {
  const t = useTranslate();
  const { form, formProps } = formData;
  const { onFinishHandler } = eventHandler;
  const { unifiedList } = stateData;
  const { type } = staticData;
  const { disabled } = configData;

  const activeStatus = [
    { label: t('rulePlans.rulePlanActive'), value: true },
    { label: t('rulePlans.rulePlanInactive'), value: false },
  ];
  const initialValues = { rule_plan_is_active: true };
  const isValuesPresent = formProps?.initialValues?.results || initialValues;

  return (
    <Form
      {...formProps}
      form={form}
      id="rule-change-plan-form"
      onFinish={onFinishHandler}
      disabled={type === 'Show' || disabled}
      initialValues={isValuesPresent}
      size="large"
      layout="vertical"
    >
      <Row gutter={16}>
        <Col xs={24} lg={12}>
          <TextInput
            label={t('rulePlans.rulePlansName')}
            name="rule_plan_name"
            required={true}
            message={t('rulePlans.messages.rulePlansName')}
            placeholder={t('rulePlans.messages.rulePlansName')}
            disabled={type === 'Show'}
            rules={{
              pattern: regex.nameCheck,
              message: t('errorMessages.rulenameValidMsg'),
            }}
          />
        </Col>
        <Col xs={24} lg={12}>
          <RangeInput
            label={t('rulePlans.rulePlanDate')}
            name="rule_plans_date"
            required={true}
            message={t('rulePlans.messages.rulePlanDate')}
            format={constants.dateFormat}
            disabled={type === 'Show'}
          />
        </Col>
        <Col xs={24} lg={12}>
          <DropdownInput
            label={t('rulePlans.unifiedFile')}
            name="unified_source_master_id"
            required={true}
            optionList={unifiedList}
            message={t('rulePlans.selectUnifiedFile')}
            placeholder={t('rulePlans.selectUnifiedFile')}
            disabled={type === 'Show'}
            showSearch={true}
            optionFilterProp="label"
            filterOption={(input, option) =>
              option?.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Col>
        <Col xs={24} lg={12}>
          <DropdownInput
            label={t('rulePlans.type')}
            name="rule_plan_compensation_type"
            required={true}
            optionList={[
              { label: t('compensationType.points'), value: 'points' },
              { label: t('compensationType.cash'), value: 'cash' },
            ]}
            message={t('rulePlans.selectRulePlanType')}
            placeholder={t('rulePlans.selectRulePlanType')}
            disabled={type === 'Show'}
            showSearch={true}
            optionFilterProp="label"
            filterOption={(input, option) =>
              option?.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Col>
        <Col xs={24} lg={16}>
          <TextAreaInput
            label={t('rulePlans.rulePlanDescription')}
            name="rule_description"
            message={t('rulePlans.messages.rulePlanDescription')}
            placeholder={t('rulePlans.messages.rulePlanDescription')}
            rows={4}
            required={false}
            disabled={type === 'Show'}
          />
        </Col>
        <Col xs={24} lg={8}>
          <label className="floating-label">{t('common.status')}</label>
          <SegmentInput
            name="rule_plan_is_active"
            optionList={activeStatus}
            disabled={type === 'Show'}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default RulePlanForm;
